// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  country_id: number
  country_name: string
}

export function useCountryById(): {
  data: Type | null
  isLoading: boolean
  fetchData: (country_id: number | string) => void
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchData = (country_id: number | string) => {
    setLoading(true)

    api.get(
      "/countries/byid",
      { params: { country_id } }
    ).then((res: SuccessFetch<{
      payload: Type
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, fetchData }
}